import type {
  WorldHostPresentationPrefs,
} from "@dawn/adapters";
import type { WorldMapScenario, WorldState } from "@dawn/engine";
import { createGameplayAnalyticsPort } from "@/analytics/createGameplayAnalyticsPort";
import { isStagingDeploy } from "@/shared/deployTarget";

interface GameSessionLaunchOptions {
  worldSavedSnapshot?: WorldState | null;
  worldSavedPresentation?: WorldHostPresentationPrefs | null;
  worldSavedMapScenario?: WorldMapScenario | null;
}

export interface GameSessionHandle {
  launch(options?: GameSessionLaunchOptions): Promise<void>;
  dispose(): void;
}

export interface CreateGameSessionOptions {
  canvas: HTMLCanvasElement;
  hudRoot: HTMLElement;
  onExit: () => void;
}

export async function createGameSession(
  options: CreateGameSessionOptions,
): Promise<GameSessionHandle> {
  const { createBabylonHost } = await import("@dawn/host-babylon/createBabylonHost");
  // Staging keeps the e2e bridge so soak can hit a deployed build; production stays off.
  return createBabylonHost({
    ...options,
    publishTestBridge: import.meta.env.DEV || isStagingDeploy(),
    analytics: createGameplayAnalyticsPort(),
    deployTarget: isStagingDeploy() ? "staging" : "production",
  });
}
